import { Language } from '@/i18n/settings';
import { LanguageCode } from '@/public/tv/charting_library';

export const localeMap: { [key in Language]: LanguageCode } = {
  'en-US': 'en',
  'zh-CN': 'zh',
};
